module.exports = __webpack_public_path__ + "img/EgyptTechPriestCost1_ua.3e12e8ce.webp";